import { UseQueryOptions, useQuery } from 'react-query';

import axiosClient from '@lib/utils/axiosClient';

const fetchPatientFormsDocusign = async () => {
  const response = await axiosClient.get('/v2/patientforms/docusign/templates');
  return response.data;
};

export default function usePatientFormsDocusign(options?: Omit<UseQueryOptions<unknown>, 'queryKey' | 'queryFn'>) {
  return useQuery('patientFormsDocusign', fetchPatientFormsDocusign, options);
}
